import { NgModule } from '@angular/core';

import { EffectsModule, provideEffects } from '@ngrx/effects';
import { provideState, StoreModule } from '@ngrx/store';

import { DeprecatedIntelligenceSettingsEffects } from './intelligence-settings-effects.service';
import {
  DeprecatedIntelligenceSettingsNamespace,
  DeprecatedIntelligenceSettingsReducer,
} from './intelligence-settings.store';

@NgModule({
  imports: [
    StoreModule.forFeature(
      DeprecatedIntelligenceSettingsNamespace,
      DeprecatedIntelligenceSettingsReducer,
    ),
    EffectsModule.forFeature([DeprecatedIntelligenceSettingsEffects]),
  ],
})
export class DeprecatedIntelligenceSettingsDataModule {}

export const deprecatedProvideIntelligenceSettingsState = provideState(
  DeprecatedIntelligenceSettingsNamespace,
  DeprecatedIntelligenceSettingsReducer,
);
export const deprecatedProvideIntelligenceSettingsEffects = provideEffects([
  DeprecatedIntelligenceSettingsEffects,
]);
